/* ============================================================
   CatchTheCar GmbH — lightbox.js
   Custom lightbox: overlay, prev/next, keyboard nav.
   No external library. Photo + video support.
   ============================================================ */

(function() {
  'use strict';

  var lightbox = null;
  var closeBtn = null;
  var prevBtn = null;
  var nextBtn = null;
  var mediaEl = null;
  var captionEl = null;

  var items = [];     // all lightbox-enabled items on current page
  var currentIndex = 0;
  var isOpen = false;
  var previousFocus = null;
  var scrollbarWidth = 0;

  /* ----------------------------------------------------------
     SETUP — called after DOM ready
     ---------------------------------------------------------- */
  function init() {
    lightbox = document.getElementById('lightbox');
    if (!lightbox) return;

    closeBtn  = document.getElementById('lightbox-close');
    prevBtn   = document.getElementById('lightbox-prev');
    nextBtn   = document.getElementById('lightbox-next');
    mediaEl   = document.getElementById('lightbox-media');
    captionEl = document.getElementById('lightbox-caption');

    // Measure scrollbar width to prevent layout shift when body overflow hides
    scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    // Bind controls
    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', function() { navigate(-1); });
    nextBtn.addEventListener('click', function() { navigate(1); });

    // Close on backdrop click
    lightbox.addEventListener('click', function(e) {
      if (e.target === lightbox) close();
    });

    // Keyboard
    document.addEventListener('keydown', onKeyDown);

    // Bind portfolio items
    bindItems();
  }

  /* ----------------------------------------------------------
     BIND ITEMS — find all clickable portfolio cards
     ---------------------------------------------------------- */
  function bindItems() {
    var groups = document.querySelectorAll('[data-lightbox-group]');

    groups.forEach(function(group) {
      var groupItems = group.querySelectorAll('[data-lightbox-src], [data-video-url]');

      groupItems.forEach(function(item) {
        item.addEventListener('click', function() {
          // Build items array for this group
          items = Array.from(groupItems);
          currentIndex = items.indexOf(item);
          openItem(currentIndex);
        });
      });
    });
  }

  /* ----------------------------------------------------------
     OPEN
     ---------------------------------------------------------- */
  function open() {
    if (isOpen) return;
    isOpen = true;
    previousFocus = document.activeElement;

    lightbox.classList.add('open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = scrollbarWidth + 'px';

    closeBtn.focus();
  }

  function openItem(index) {
    currentIndex = index;
    var item = items[index];
    if (!item) return;

    var videoUrl = item.dataset.videoUrl;
    var imgSrc = item.dataset.lightboxSrc;
    var title = item.dataset.lightboxTitle || '';
    var client = item.dataset.lightboxClient || '';

    // Clear media
    mediaEl.innerHTML = '';

    if (videoUrl) {
      // Embed YouTube / Vimeo
      var iframe = document.createElement('iframe');
      iframe.src = getEmbedUrl(videoUrl);
      iframe.width = '900';
      iframe.height = '506';
      iframe.style.cssText = 'max-width:90vw; max-height:70vh; width:100%; border:none;';
      iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('title', title || 'Video');
      mediaEl.appendChild(iframe);
    } else if (imgSrc) {
      var img = document.createElement('img');
      img.src = imgSrc;
      img.alt = title || '';
      img.style.cssText = 'max-width:90vw; max-height:85vh; object-fit:contain; display:block;';
      mediaEl.appendChild(img);
    }

    // Caption
    if (captionEl) {
      var caption = [title, client].filter(Boolean).join(' · ');
      captionEl.textContent = caption;
    }

    // Show/hide prev/next
    prevBtn.style.display = items.length <= 1 ? 'none' : '';
    nextBtn.style.display = items.length <= 1 ? 'none' : '';

    open();
  }

  /* ----------------------------------------------------------
     CLOSE
     ---------------------------------------------------------- */
  function close() {
    if (!isOpen) return;
    isOpen = false;

    lightbox.classList.remove('open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';

    // Stop video
    mediaEl.innerHTML = '';

    if (previousFocus) previousFocus.focus();
  }

  /* ----------------------------------------------------------
     NAVIGATE
     ---------------------------------------------------------- */
  function navigate(dir) {
    var next = (currentIndex + dir + items.length) % items.length;
    openItem(next);
  }

  /* ----------------------------------------------------------
     KEYBOARD
     ---------------------------------------------------------- */
  function onKeyDown(e) {
    if (!isOpen) return;
    switch (e.key) {
      case 'Escape':
        close();
        break;
      case 'ArrowLeft':
        navigate(-1);
        break;
      case 'ArrowRight':
        navigate(1);
        break;
      // Trap Tab within lightbox
      case 'Tab': {
        var focusables = lightbox.querySelectorAll('button, iframe, [tabindex]:not([tabindex="-1"])');
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault(); first.focus();
        }
        break;
      }
    }
  }

  /* ----------------------------------------------------------
     EMBED URL HELPER
     ---------------------------------------------------------- */
  function getEmbedUrl(url) {
    // YouTube
    var ytMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]+)/);
    if (ytMatch) {
      return 'https://www.youtube.com/embed/' + ytMatch[1] + '?autoplay=1&rel=0';
    }
    // Vimeo
    var vmMatch = url.match(/vimeo\.com\/(\d+)/);
    if (vmMatch) {
      return 'https://player.vimeo.com/video/' + vmMatch[1] + '?autoplay=1';
    }
    return url;
  }

  /* ----------------------------------------------------------
     INIT
     ---------------------------------------------------------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
